<template>
  <ElDialog name="data-export-modal"
    :visible="show"
    v-on="$listeners"
    v-loading="loading"
    :title="$t('companySettings.data.exportType', { type })"
    append-to-body
  >
    <p>{{ $t('companySettings.data.exportModalMessage', { type }) }}</p>
    <p>
      <VMessage v-if="typeCount" type="warning" subtype="outlined" :fullwidth="true">
        <template v-slot:icon>
          <ExclamationTriangleIcon />
        </template>
        <template v-slot:text>
          {{ $t('companySettings.data.exportModalWarning', { type, typeCount }) }}
        </template>
      </VMessage>
    </p>
    <div class="modal-buttons">
      <VButton
          type="cta-1"
          @click.native="triggerExport"
          data-ec="data_export_modal"
          data-et="export_button">
        <span>{{ $t('companySettings.data.exportType', { type }) }}</span>
      </VButton><br />
    </div>
  </ElDialog>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import useList from '@/composables/list/list';
import { ListEnvelope } from '@/store/modules/envelopes/models';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ExportDataModal',
  components: {
    VButton,
    VMessage,
    ExclamationTriangleIcon,
  },
  props: {
    show: Boolean,
    type: String,
  },
  data() {
    return {
      loading: false,
    };
  },
  setup() {
    const [
      fetchEnvelopeData,
      results, // eslint-disable-line
      envelopesData,
    ] = useList('envelopes', ListEnvelope);

    return {
      fetchEnvelopeData,
      envelopesData,
    };
  },
  mounted() {
    this.fetchEnvelopeData({
      limit: 1,
    });
    this.$store.dispatch('templates/PAGINATE', { page: 1, pageLimit: 1 });
    this.$store.dispatch('users/PAGINATE', { page: 1, pageLimit: 1 });
    this.$store.dispatch('contacts/PAGINATE', { page: 1, pageLimit: 1 });
  },
  computed: {
    typeCount() {
      switch (this.type) {
        case 'envelopes':
          return this.envelopesData.total;
        case 'templates':
          return this.$store.getters['templates/totalCount'];
        case 'contacts':
          return this.$store.getters['contacts/totalCount'];
        case 'users':
          return this.$store.getters['users/totalCount'];
        default:
          return null;
      }
    },
  },
  methods: {
    triggerExport() {
      this.loading = true;
      this.$store.dispatch('company/EXPORT_DATA', { type: this.type }).finally(() => {
        this.$emit('exportTriggered', this.type);
        this.$emit('close');
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
p {
  word-break: normal;
}

.modal-buttons {
  text-align: right;
}

.modal-buttons .a-button {
  display: inline-block;
  float: none;
}
</style>
